'use client';

import { useState } from 'react'
import Image from 'next/image';
import { usePathname } from 'next/navigation';

// Assets
import Century21 from '@public/png/century-21-black-1.png';
import IconX from '@public/png/x-1.png';

// Hooks
import useWhatsappMessage from '@src/hooks/useWhatsapp';

const phone = '6281295000888'

const pathsToShowBtn = [
  "/",
  "/jual",
  "/about-us",
  "/about-us",
  "/contact",
  "/franchise",
]

const shouldShowElement = (pathname) => {
  return pathsToShowBtn.some((path) => {
    if (path.includes('*')) {
      const basePath = path.replace('*', '');
      return pathname.startsWith(basePath);
    } else if (path.includes('[id]')) {
      const regex = new RegExp(path.replace('[id]', '[^/]+'));
      return regex.test(pathname);
    }
    return pathname === path;
  });
};

const FloatingBtn = () => {
  const [open, setOpen] = useState(true)
  const { sendMessage } = useWhatsappMessage();
  const pathname = usePathname()

  const showElement = shouldShowElement(pathname);


  const handleSendMessage = (type = "button") => {
    if (type === "anchor") {
      return sendMessage({
        phone: phone,
        type,
        message: "Halo, saya tertarik untuk mendapatkan info lebih lanjut terntang franchise kantor Century 21 Indonesia"
      })
    }

    sendMessage({
      phone: phone,
      type,
      message: "Halo, saya tertarik untuk mendapatkan info lebih lanjut terntang franchise kantor Century 21 Indonesia"
    })
  }

  if (!open || !showElement) return null
  return (
    <div className='fixed z-[40] bottom-[46px] right-[107.725px] 
      dd-xl:right-[32px] dd-xl:bottom-[32px] 
      dd-md:right-[16px] dd-md:bottom-[16px] 
      dd-sm:right-[8px] dd-sm:bottom-[8px] 
      '>
      <div className='relative p-2 pl-4 flex items-center bg-[#FFC62E] rounded-[24px] shadow-[0px_0px_16px_0px_rgba(37,37,38,0.24)]'>
        <button onClick={() => setOpen(false)} className='cursor-pointer absolute z-[41] top-[-4px] left-[-4px] p-1 rounded-[24px] flex items-center justify-center bg-white'>
          <Image
            src={IconX}
            alt="Close icon"
            width="auto"
            height="auto"
            className='object-contain w-[12px] h-[12px]'
          />
        </button>
        <div className='flex items-center mr-4'>
          <span className='text-13 mr-1'>Buka kantor</span>
          <Image
            src={Century21}
            alt="CENTURY 21 Indonesia"
            width="auto"
            height="auto"
            className='object-contain w-[89.275px] h-[10px]'
          />
        </div>
        <button onClick={handleSendMessage} className='c-button text-white text-15'>Hubungi Kami</button>
      </div>
    </div>
  )
}

export default FloatingBtn